export const COMPARE_ACTIONS = [
  {
    title: 'Differential Expression',
    jobType: 'de',
    version: '1.0.0',
    tooltip:
      'Find differentially expressed features between two groups of cells',
  },
];
